export type Sample = {
  sym: string; name: string; addr: string; pool: string; fee: number
  ts: string; sessionState: 'open' | 'closed' | 'holiday' | 'half-day-closed'; hasRef?: boolean
  onchainEth?: number | null; onchainUsd?: number | null; ethUsd?: number | null
  refUsd?: number | null; refAt?: string | null; refSource?: string | null
  refAgeMs?: number | null; premiumBps?: number | null; withheld: string | null
}
export type Board = {
  at: string; session: Sample['sessionState']
  week: { openHours: number; totalHours: number; closedHours: number; closedPct: number }
  tokens: Sample[]
}
export type Config = { ca: string | null; ticker: string; xUrl: string; signupOpen: boolean }
export type SeriesPoint = {
  ts: string; onchain_usd: number | null; ref_usd: number | null
  premium_bps: number | null; session_state: string; withheld: string | null
}

async function get<T>(url: string): Promise<T> {
  const r = await fetch(url, { headers: { accept: 'application/json' } })
  if (!r.ok) throw new Error(`${url} → ${r.status}`)
  return r.json()
}

export const getBoard = () => get<Board>('/api/board')
export const getConfig = () => get<Config>('/api/config')
export const getSeries = (sym: string, range: string) =>
  get<{ sym: string; hours: number; points: SeriesPoint[]; note?: string }>(`/api/series/${sym}?range=${range}`)
export const getHeatmap = (sym: string) =>
  get<{ sym: string; cells: { dow: number; hour: number; mean_bps: number; n: number }[]; note?: string }>(`/api/heatmap/${sym}`)

export async function signup(email: string) {
  const r = await fetch('/api/signup', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email }),
  })
  const j = await r.json().catch(() => ({}))
  if (!r.ok) throw new Error(j.error || 'Could not save that.')
  return j as { ok: true; alreadyOn: boolean }
}
